import axios from 'axios';

import { apiUrl } from '../config';
import { useAuthStore } from '../stores/authStore';

const client = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  validateStatus: (status) => status >= 200 && status < 500,
});

client.interceptors.request.use((config) => {
  const { accessToken } = useAuthStore.getState();
  if (accessToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

client.interceptors.response.use((response) => {
  if (response.status === 401) {
    useAuthStore.getState().logout();
  }

  return response;
});

export { client };
